// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"190":"f3e92911","536":"0cb61c45"}[chunkId] + ".chunk.js";
};